export default __webpack_public_path__ + "static/media/640_store04-it-mobile.5bb6a675.png";